import Vue from 'vue';
import Router from 'vue-router';
import Onboarding from '@/components/Onboarding';
import Palettes from '@/components/Palettes';
import BigPalette from '@/components/BigPalette';
import Submit from '@/components/Submit';
import Subscribe from '@/components/Subscribe';
import Policy from '@/components/Policy';

Vue.use(Router);

// let isMobile = false;

// if (
//     navigator.userAgent.match(/Android/i) ||
//     navigator.userAgent.match(/webOS/i) ||
//     navigator.userAgent.match(/iPhone/i) ||
//     navigator.userAgent.match(/iPod/i) ||
//     navigator.userAgent.match(/iPad/i) ||
//     navigator.userAgent.match(/BlackBerry/i) ||
//     navigator.userAgent.match(/IEMobile/i) ||
//     navigator.userAgent.match(/Opera Mini/i)
// ) {
//     isMobile = true;
// }

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Palettes',
            beforeEnter: (to, from, next) => {
                next();
                //DEBUG
                // localStorage.removeItem('onboardingShown');
                // if (
                //     localStorage.getItem('onboardingShown') === null &&
                //     !isMobile
                // ) {
                //     localStorage.setItem('onboardingShown', true);
                //     next('/onboarding');
                //     return;
                // }
                // next();
            },
            component: Palettes
        },
        {
            path: '/onboarding',
            name: 'Onboarding',
            component: Onboarding
        },
        // {
        //     path: '/palettes',
        //     name: 'Palettes',
        //     component: Palettes
        // },
        {
            path: '/palette/:id',
            name: 'BigPalette',
            component: BigPalette
        },
        {
            path: '/submit',
            name: 'Submit',
            component: Submit
        },
        {
            path: '/policy',
            name: 'Cookie Policy',
            component: Policy
        },
        {
            path: '/subscribe',
            name: 'Subscribe',
            component: Subscribe
        }
    ],
    scrollBehavior(to, from) {
        if (from.name === 'Palettes') {
            //Save position
            localStorage.setItem(
                'scrollY',
                document.getElementsByTagName('html')[0].scrollTop
            );
            // console.log(localStorage.getItem('scrollY'));
        }
        return new Promise(resolve => {
            setTimeout(() => {
                if (to.name !== 'Palettes' || from.name === 'Onboarding') {
                    resolve({ x: 0, y: 0 });
                }
                else if (
                    to.name === 'Palettes' &&
                    localStorage.getItem('scrollY')
                ) {
                    // console.log(localStorage.getItem('scrollY'));
                    resolve({
                        x: 0,
                        y: parseInt(localStorage.getItem('scrollY'))
                    });
                }
            }, 500);
        });
    }
});



// WEBPACK FOOTER //
// ./src/router/index.js